import { businessDeposit, } from '@/apis/crypto';
import { useGlobalVerify } from "@/logic/verify";
import { CryptoMerchantInfo, useCryptoMerchantInfoStore } from "@/stores/CryptoMerchatStore";
import { useUserInfoStore } from "@/stores/userInfo";
import { Toast } from "antd-mobile";
import { FormInstance } from "antd-mobile/es/components/form";
import { useCallback, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";


const formmatCryptoBalance = (cryptoMerchantInfo: CryptoMerchantInfo, value: number) =>  {
  if (Number(value) > Number(cryptoMerchantInfo.businessBalance)) {
    return parseFloat(cryptoMerchantInfo.businessBalance).toFixed(2);
  }
  return value || "";
}

const valiedateData = (data: {amount: number, paymentType: string}) => {
  if(!data.amount){
    return ('请输入转出金额');
  }

}
let orderType = 'BusinessTransferVippayOut';


export const useLogic = () => {
  const formRef = useRef<FormInstance>();
  const [verifySecurePassword] = useGlobalVerify();
  const userInfo = useUserInfoStore()(state => state.userInfo);
  const cryptoMerchantInfo = useCryptoMerchantInfoStore(state => state.cryptoMerchantInfo);
  const getCryptoMerchantInfo = useCryptoMerchantInfoStore(state => state.getCryptoMerchantInfo);

  const navigate = useNavigate();

  useEffect(() => {
    getCryptoMerchantInfo();
  }, [])

  useEffect(() => {
    formRef.current?.setFieldsValue({
      balance: cryptoMerchantInfo.businessBalance,
    });
  }, [cryptoMerchantInfo.businessBalance])

  const onFormRef = useCallback((form: FormInstance) =>{
    formRef.current = form;
    form.setFieldsValue({
      balance: userInfo.balance,
      before_balance:  userInfo.balance,
      mainNet: 'VipPay钱包余额',
    });
  },[])


   // 提交订单
  const submit = async ()=>{
    const data = formRef.current?.getFieldsValue();
    const valiedateMsg = valiedateData(data);
    if(valiedateMsg){
      return Toast.show(valiedateMsg)
    }
    // TODO: 验证资金密码
    const securePassword = await verifySecurePassword();
    if (!securePassword) return;
    const { ok, msg } = await businessDeposit({
      paymentType: undefined,
      amount: parseFloat(data.amount).toFixed(2),
      passageType: orderType,
      receivingAddress: undefined,
      securePassword: securePassword as string,
    });
    if (ok) {
      Toast.show("转出成功");
      navigate(-1);
    } else {
      Toast.show(msg);
    }

  }

  const onSubmit = useCallback(() => {
      submit();
  }, [])

  const onValuesChange = (values:any, allValues: any) => {
    const changeKeys = Object.keys(values);
    if(changeKeys.includes('amount')){
      const amount = formmatCryptoBalance(cryptoMerchantInfo, values.amount);
      const after_balance =  Number(userInfo.balance) + Number(amount || "0")
      formRef.current?.setFieldsValue({
        amount,
        after_balance
      })
    }
  }
  const addAll = () => {
    const amount = parseFloat(cryptoMerchantInfo.businessBalance).toFixed(2)
    const after_balance =  Number(userInfo.balance) + Number(amount || "0")
    formRef.current?.setFieldsValue({
      amount,
      after_balance
    })
  }

  return {
    onFormRef,
    onSubmit,
    onValuesChange,
    addAll
  }
}
